import { request as sonataRequest } from 'sonata-react-components';

import { convertDatesToStringDateFilter } from '@/helpers/common/date.helper';

import type { Moment } from 'moment-timezone';
import type { PaginationRequestParams } from 'sonata-static-storage/lib/common/common.types';
import type { Pixel } from 'sonata-static-storage/lib/schemas/pixel/pixel.schema';
import type { Token } from './common.types';

type Filters = {
  date?: {
    beginDate?: Moment | string;
    endDate?: Moment | string;
  };
  pixelsIds?: string[];
  type?: Pixel['type'][];
  subtype?: Pixel['codeType'][];
  name?: Pixel['name'] | null;
};

type Payload = Filters & PaginationRequestParams;

export async function getPixels(
  payload: Payload,
  userId: string,
  token: Token
): Promise<{
  currentPage: number;
  items: Pixel[];
  totalItems: number;
  itemsPerPage: number;
}> {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}user/${userId}/pixels`,
    {
      data: {
        itemsPerPage: payload?.itemsPerPage ?? 15,
        order: 'desc',
        page: payload?.page ?? 1,
        sortBy: 'modified',
        ...(payload.pixelsIds ? { filterPids: payload.pixelsIds } : {}),
        ...(payload.date ? { filterDate: convertDatesToStringDateFilter(payload.date) } : {}),
        ...(payload.fields ? { fields: payload.fields } : {}),
        ...(payload.name ? { filterString: payload.name } : {}),
        ...(payload.subtype ? { filterSubtype: payload.subtype } : {}),
        ...(payload.type ? { filterType: payload.type } : {})
      },
      method: 'POST'
    },
    token
  );
}

export function createPixel(pixel: Partial<Pixel>, userId: string, token?: Token): Promise<Pixel> {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}user/pixel`,
    {
      data: {
        campaigns: [],
        codeType: pixel.codeType,
        conversions: -1,
        features: pixel.features,
        name: pixel.name,
        placement: pixel.placement,
        selected: false,
        stats: {
          aggregated: {},
          aggregatedByDay: [],
          byCampaign: {},
          byCampaignAndDay: {}
        },
        type: pixel.type,
        userId: userId
      },
      method: 'POST'
    },
    token
  );
}

export function updatePixel(pixel: Pixel, token?: Token): Promise<Pixel> {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}user/pixel/${pixel._id}`,
    {
      data: pixel,
      method: 'PUT'
    },
    token
  );
}
